import React from "react";
import PropTypes from "prop-types";
import { Message } from "@qgiv/core-react";

const FCRegistrationBanner = ({
    hasParentRegistration = false,
    parentRegistration = {},
}) => {
    const { First_Name = "", Last_Name = "" } = parentRegistration;
    return hasParentRegistration ? (
        <div className="grid">
            {/* Keep spacing above and below RegistrationContent consistent */}
            <div className="col col--12 -padding-top--30">
                <Message type="fcRegistration">
                    Adding someone to {`${First_Name} ${Last_Name}`}
                    &apos;s registration.
                </Message>
            </div>
        </div>
    ) : null;
};

FCRegistrationBanner.propTypes = {
    hasParentRegistration: PropTypes.bool.isRequired,
    parentRegistration: PropTypes.shape({}),
};

export default FCRegistrationBanner;
